<template style='height：100%'>
    <div class="box">
        <el-container>
            <el-header>
                <headerList></headerList>
            </el-header>
            <el-main>
                <div class="content">
                    <div class="title" v-html="obj.title">

                    </div>
                    <div class="date" v-html='updateTime(obj.created)'>

                    </div>
                    <el-divider></el-divider>
                    <div class='demo'>
                        <video-player class="video-player vjs-custom-skin"
                                      ref="videoPlayer"
                                      :playsinline="true"
                                      :options="playerOptions">
                        </video-player>
                    </div>
                </div>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    import headerList from "./public/header";
    export default {
        name: "consultDetail",
        components: { headerList },
        data() {
            return {
                form: {
                    name: "",
                    region: "",
                    date1: "",
                    date2: "",
                    delivery: false,
                    type: [],
                    resource: "",
                    desc: "",
                },
                obj:this.$route.query,
                playerOptions: {
                    //播放速度
                    playbackRates: [0.5, 1.0, 1.5, 2.0],
                    //如果true,浏览器准备好时开始回放。
                    autoplay: false,
                    // 默认情况下将会消除任何音频。
                    muted: false,
                    // 导致视频一结束就重新开始。
                    loop: false,
                    // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    preload: 'auto',
                    language: 'zh-CN',
                    // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    aspectRatio: '16:9',
                    // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    fluid: true,
                    sources: [{
                        //类型
                        type: "video/mp4",
                        //url地址
                        src:'http://hk-huanggang.oss-cn-hangzhou.aliyuncs.com/'+this.$route.query.video,
                    }],
                    //你的封面地址
                    poster: '',
                    //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    notSupportedMessage: '此视频暂无法播放，请稍后再试',
                    controlBar: {
                        timeDivider: true,
                        durationDisplay: true,
                        remainingTimeDisplay: false,
                        //全屏按钮
                        fullscreenToggle: true
                    }
                }
            };
        },
        created(){
            this.init();
        },
        methods: {
             updateTime(item){
                let newList= item.split("T");
            return newList[0]
            },
           init(){

           }
        },
    };
</script>
<style scoped>
    .box {
        position: relative;
        top: 0;
        left: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        margin: 0 auto;
    }
    .el-container {
        padding: 0;
        margin: 0;
        width: 100%;
        height: 100%;
    }
    .el-header {
        width: 100%;
        height: 7.1875rem /* 115px -> 7.1875rem */ !important;
        line-height: 7.1875rem /* 115px -> 7.1875rem */;
        background-color: #fff;
        color: #333;
        text-align: center;
        position: fixed;
        background: rgba(255, 255, 255, 0.8);
        top: 0;
        left: 0;
        z-index: 99;
    }
    .el-main {
        width: 87.375rem /* 1398px -> 87.375rem */;
        min-height: 100rem /* 1945px -> 121.5625rem */;
        background: #FDFBF5;
        box-shadow: 0px 2px 28px 2px rgba(198, 186, 173, 0.35);
        /*opacity: 0.6;*/
        margin: 0 auto;
        position: relative;
        top: 0;
        left: 0;
    }
    .content {
        width: 78rem /* 1248px -> 78rem */;
        height: 96rem /* 1536px -> 96rem */;
        margin:9.375rem /* 150px -> 9.375rem */ auto;
        border: 2px solid #C1B8AF;

    }
    .title{
        height: 6.25rem /* 100px -> 6.25rem */;
        font-size: 2rem /* 32px -> 2rem */;
        text-align: center;
        line-height: 6.25rem /* 100px -> 6.25rem */;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
    }
    .date{
        height:.875rem /* 14px -> .875rem */;
        font-size: 1rem /* 16px -> 1rem */;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #000000;
        text-align: left;
        margin-left:3.125rem /* 50px -> 3.125rem */;
    }
    .text{
        width:65rem /* 1040px -> 65rem */;
        margin: 1.875rem /* 30px -> 1.875rem */ auto;
        height: 40.3125rem /* 645px -> 40.3125rem */;
        font-size: 1.125rem /* 18px -> 1.125rem */;
        text-indent:2em;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #000000;
        line-height: 1.875rem /* 30px -> 1.875rem */;
        letter-spacing:3px;

    }
    .pic{
        width: 80%;
        height: 28.3125rem /* 453px -> 28.3125rem */;
        margin:3.125rem /* 50px -> 3.125rem */ auto;
    }
    .demo{
        display: inline-block;
        width: 80%;
        height: 50%;
        text-align: center;
        line-height: 6.25rem /* 100px -> 6.25rem */;
        margin: 10%;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
        margin-right: 4px;
    }

    .demo:hover{
        display: block;
    }
</style>
